import React, { useContext, useEffect, useState } from 'react'
import { NotificationPush } from '../helpers/api'
import { UserContext } from '../contexts/UserContext'
import Table from '../components/table/table'

const ListeNotificationPush = () => {
  const {user}= useContext(UserContext)
  const [currentPage, setCurrentPage]= useState(1)
  const [totalPage, setTotalPage]= useState()
  const [isLoading, setIsLoading]=useState(true)
  const [listData, setListData]=useState([])
  const [pageSize, setPageSize]=useState(10)

  const columns = [
    {
      label: "Date et Heure",
      key: "date",
      customRenderers: (row) => <div >{row.createdAt}</div>,
    },
    {
      label: "title",
      key: "title",
      customRenderers: (row) => <div>{row.title}</div>,
    },
    {
      label: "description",
      key: "description",
      customRenderers: (row) => 
        <div className="max-h-[100px] overflow-y-auto  whitespace-normal">
        {row.description}
        </div>
    },
]
    useEffect(()=>{
        const ListeNotification= async ()=>{
            const response = await NotificationPush(user?.accessToken, currentPage,pageSize)
            if (response.success)
            {
                setListData(response.notifications)
                setIsLoading(false)
                setTotalPage (response.pagination?.total)
                console.log('response',response )
        }


        } 
       if (user?.accessToken){ ListeNotification()}
    }, [currentPage, pageSize])

   
  return (
    <div>
        <Table
          titleTable='Notifications'
          totalPage={totalPage}
          setPageSize={setPageSize}
          pageSize={pageSize}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          data={listData}
          columns={columns}
          loading={isLoading}
          className='table-fixed w-full min-w-max'
         
        />
    </div>
  )
}

export default ListeNotificationPush
